import React from "react";
import "./openAccountBanner.scss";
import "./openAccountBanner.scss";
import StickyLogo from "../../assets/images/logo/bottom-sticky.svg";
import Separator from "../../assets/images/icons/ic_separator.svg";
import PlusIcon from "../../assets/images/icons/ic_plus.svg";
import { DEEP_LINK_URL } from "../../constants/headerConstants";

const OpenAccountBanner = () => {
  return (
    <div className="open-account-banner">
      <div className="brand-logo">
        <img src={StickyLogo} alt="Share.Market Logo" />
      </div>
      <div className="separator">
        <img src={Separator} />
      </div>
      <div className="content">
        <div>
          <div className="sub-title">
            Start Investing With
          </div>
          <div className="title">
            <span className="text">
              ₹0 Account Opening Fee
            </span>
            <img src={PlusIcon} alt="Plus Icon" />
            <span className="text">
              ₹0 brokerage fee on all orders
            </span>
          </div>
          <div className="date">
            Valid Till 31st March, 2025*
          </div>
        </div>
      </div>
      <div className="separator">
        <img src={Separator} />
      </div>
      <div className="cta-container">
        <span className="text">
          ₹0 brokerage fee on all orders till 31st Dec’24
        </span>
        <a
          href={DEEP_LINK_URL}
          target="_blank"
          className="cta"
          rel="noreferrer"
        ></a>
      </div>
    </div>
  );
};

export default OpenAccountBanner;
